import styled from 'styled-components'
import {ContentContainer} from '@components/lib'

export const Container = styled(ContentContainer)`
  padding-top: 20px;
  padding-bottom: 15px;
  color: ${({theme}) => theme.colors.textSecondary};
  font-size: ${({theme}) => theme.fontSizes.extraSmall};
  line-height: 1.2;
  display: flex;
  align-items: center;
  justify-content: center;

  ${({theme}) => theme.breakpoints.down('mobileL')} {
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
`

export const LinksWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;

  & > * {
    margin: 3px 8px;
  }
`

export const Copyright = styled.span`
  display: inline-block;
  ${({theme}) => theme.breakpoints.down('mobileL')} {
    margin-top: 15px;
  }
`
